import { render, staticRenderFns } from "./product-inventory-list.vue?vue&type=template&id=84c7e958&scoped=true&"
import script from "./product-inventory-list.vue?vue&type=script&lang=ts&"
export * from "./product-inventory-list.vue?vue&type=script&lang=ts&"
import style0 from "./product-inventory-list.vue?vue&type=style&index=0&id=84c7e958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c7e958",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84c7e958')) {
      api.createRecord('84c7e958', component.options)
    } else {
      api.reload('84c7e958', component.options)
    }
    module.hot.accept("./product-inventory-list.vue?vue&type=template&id=84c7e958&scoped=true&", function () {
      api.rerender('84c7e958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/products/components/product-inventory-list.vue"
export default component.exports